import { Formulaires } from "@/utils/formulaireDefinitions";

export function goToNextTab($route, $router, autorisations, back = false) {
  const formulaireTabs = getFormulaireTabs($route.name);
  const current = formulaireTabs?.find((tab) => $route.name === tab.componentPath);

  if (!current) {
    return;
  }

  const nextTabs = back
    ? formulaireTabs.filter((tab) => tab.index < current.index).reverse()
    : formulaireTabs.filter((tab) => tab.index > current.index);
  const nextTab = getNextTab(nextTabs, autorisations);

  if (nextTab) {
    $router.push({
      name: nextTab.componentPath,
      query: { ...$route.query },
    });
  }
}

function getFormulaireTabs(routeName) {
  return Formulaires.find((formulaire) => routeName.startsWith(formulaire.routeName))?.getTabs();
}

function getNextTab(nextTabs, autorisations) {
  return nextTabs.find((tab) => {
    return isAccessible(tab, autorisations);
  });
}

export function isAccessible(tab, autorisations) {
  if (!tab.condition) {
    return true;
  }

  const options = {
    autorisations: autorisations,
  };

  return tab.condition(options);
}
